// data.js

const data1 = [
  {
    title: 'Product Title 1',
    description: 'Description of Product 1',
  },
  {
    title: 'Product Title 1',
    description: 'Description of Product 1',
  },
  {
    title: 'Product Title 1',
    description: 'Description of Product 1',
  },
  {
    title: 'Product Title 1',
    description: 'Description of Product 1',
  },

];

export default data1;
